module.exports = __webpack_public_path__ + "media/signup-react/get-rewarded-19432b24.png";